/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import {
    CalendarIcon,
    DocumentationIcon, IconDepartment,
} from "../../../../../../../components/buttons/IconButtons";
import CustomGenericTittleIconDataChip from "../../../../../../../components/CustomGenericTittleIconDataChip";
import CustomChip from "../../../../../../../components/CustomChip";
import {useTranslation} from "react-i18next";
import {
    calculateHeight,
    DATE_TIME_FORMAT_NAME_MODEL,
    EMPTY_VALUES,
    getDateFormat, isSmWidth,
} from "../../../../../../../Apis/functions";
import CustomTooltip from "../../../../../../../components/CustomTooltip";
import {colors} from "../../../../../../../enums/colors";
import CustomUserChip from "../../../../../../../components/CustomUserChip";
import React, {useEffect, useRef} from "react";
import {CustomLevelCardStyle} from "../../../../../../../components/Styles";
import CustomBorderTable from "../../../../../../../components/table/CustomBorderTable";
import {requestedBatchApprovalColumns} from "../Model/Model";

const RequestedBatchOverviewTable = ({ objectItems, contentTableRef, attendancePeriod, statusId, departmentName }) => {
    const { t } = useTranslation();
    const styles = CustomLevelCardStyle(statusId, false);
    const ref = useRef(null);

    useEffect(() => {
        if (isSmWidth()) return;
        calculateHeight({ elementRef: ref, bottom: 90 });
    }, []);

    return (
        <>
            <div style={styles.container} ref={contentTableRef} className={"background-general-00"}>
                <div className={"col-12 d-flex justify-content-between align-items-center py-12px px-3 row"} style={styles.levelCard}>
                    <div className={"col-sm-12 col-md-12 col-lg-3 pl-0 pr-1"}>
                        <div>
                            <CustomGenericTittleIconDataChip
                                className="m-0"
                                Icon={DocumentationIcon}
                                title="batch_overview"
                                border={false}
                                badge={ <CustomChip
                                    background={colors.shades200}
                                    fontColor={colors.shades500}
                                    borderColor={colors.shades300}
                                    legend={objectItems?.length || 0}
                                    variant={'compact'}
                                    className={"chip-badge mb-1 justify-content-start"}
                                />}
                            />
                        </div>

                    </div>
                    <div className={"col-sm-12 col-md-12 col-lg-9 pl-1 pr-0"}>
                        <div className={"d-flex justify-content-end align-items-center w-100"}>
                            <p className={"fs-12px mr-3"}> {t("period") + ":"}</p>

                            <CustomUserChip
                                className={"m-0 p-0"}
                                name={ <CustomTooltip
                                    text={`${getDateFormat(attendancePeriod?.startDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) || EMPTY_VALUES.DEFAULT}
                                     - ${getDateFormat(attendancePeriod?.endDate, true, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) || EMPTY_VALUES.DEFAULT}` }
                                    classes={`fs-12px text-ellipsis-1-row`}
                                    showIfTruncated={true}
                                />
                                }
                                Icon={CalendarIcon}
                                showAvatar={true}
                                classNameText={"ibl-font-w-600"}
                                classNameIcon={"icon-color-shades-400"}
                            />
                        </div>
                    </div>
                </div>

                <div ref={ref}>
                    <CustomBorderTable
                        id={"tbl_rbo_batch_approval_table"}
                        rows={objectItems}
                        columns={requestedBatchApprovalColumns(t)}
                    />
                </div>
            </div>
        </>
    );
};

export default RequestedBatchOverviewTable;
